<template>
  <div class="product-detail-page-2">
    <!-- 商品总的描述 -->
    <div class="top-section flex-between">
      <!-- 左边主要内容 -->
      <div class="left-content flex-rowl">
        <div class="image-container">
          <img
            src="https://upload.vwingist.com/melscn/0image/2025/10/5738893836156167536.jpg?v=01"
            class="zoomable-image"
          />
        </div>
        <div class="text-content">
          <h1 class="title">{{ $t('productDetail2.title') }}</h1>
          <h2 class="sub_title">{{ $t('productDetail2.subTitle') }}</h2>
          <div class="description">
            <p class="txt1 mb_30">{{ $t('productDetail2.description.para1') }}</p>
            <p class="txt2 mb_40" v-html="$t('productDetail2.description.para2')">
            </p>
            <p class="txt1 mb_30">{{ $t('productDetail2.description.usageTitle') }}</p>
            <p class="txt2" v-html="$t('productDetail2.description.usageContent')">
            </p>
          </div>
          <div
            class="more-details-wrap"
            @mouseenter="showQRCode = true"
            @mouseleave="showQRCode = false"
          >
            <button class="more-details-btn flex-rowl">
              {{ $t('productDetail2.consultationButton') }}
              <i class="iconfont icon-xiangxiajiantou"></i>
            </button>
            <div class="more-details-ercode flex-colc" v-show="showQRCode">
              <div class="ercode_img">
                <img
                  src="https://upload.vwingist.com/melscn/0image/2025/05/5396193097466189276.png"
                  alt=""
                />
              </div>
              <div class="ercode_txt flex-colc">
                <p v-html="$t('productDetail2.qrCodeInfo.text1')"></p>
                <p v-html="$t('productDetail2.qrCodeInfo.text2')"></p>
                <p>{{ $t('productDetail2.qrCodeInfo.text3') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 右边商品分类折叠面板 -->
      <ProductCategoryPanel />
    </div>
    <!-- 商品详细描述 -->
    <div class="bottom-section">
      <div
        v-for="(item, index) in detailItems"
        :key="index"
        :class="[
          'bottom-section-list flex-between',
          item.length == 2 ? 'new-class-2' : '',
          item.length == 3 ? 'new-class-3' : '',
        ]"
      >
        <div
          class="detail-item"
          v-for="(itemChild, indexChild) in item"
          :key="indexChild"
        >
          <div class="top-part flex-between">
            <div class="left-text">
              <h2 class="sub-title">{{ $t(`productDetail2.detailItems[${indexChild}].subTitle`) }}</h2>
              <p class="sub-description">{{ $t(`productDetail2.detailItems[${indexChild}].subDescription`) }}</p>
            </div>
            <div class="right-image image-container">
              <img :src="itemChild.imageUrl" class="zoomable-image" />
            </div>
          </div>
          <div class="bottom-part">
            <h3 class="detail-title" v-html="$t(`productDetail2.detailItems[${indexChild}].detailTitle`)"></h3>
            <p class="detail-description" v-html="$t(`productDetail2.detailItems[${indexChild}].detailDescription`)"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductCategoryPanel from "@/components/ProductCategoryPanel.vue";

export default {
  name: "ProductDetail2",
  components: {
    ProductCategoryPanel,
  },
  data() {
    return {
      showQRCode: false,
      detailItems: [
        [
          {
            subTitle: "水潤力量",
            subDescription: "深層滋養",
            imageUrl:
              "https://upload.vwingist.com/melscn/0image/2025/03/5090123617308505977.png",
            detailTitle: "肌膚渴望水分？",
            detailDescription:
              " VESCOR面膜含有高水分保濕配方，能深層補水，讓肌膚如同喝飽了水的植物，從內而外散發水潤光澤。<br/><br/>玻尿酸精華的加入，更是讓肌膚的水潤UP UP，細膩光滑，彈性十足。<br/><br/>膠原蛋白不僅能保濕，還能緊緻肌膚，減少鬆弛，讓輪廓更加清晰，重現緊緻有彈性的年輕狀態。<br/><br/>同時，它還能增強肌膚的自我修復能力，修復受損的肌膚屏障，讓肌膚更健康、更有抵抗力。",
          },
          {
            subTitle: "明星舒緩成分",
            subDescription: "肌膚的溫柔守護",
            imageUrl:
              "https://upload.vwingist.com/melscn/0image/2025/03/5550415738397091128.png",
            detailTitle:
              "肌膚的溫柔守護者",
            detailDescription:
              "我們精心挑選了積雪草、虎杖根、黃芩根和迷迭香葉萃取物等明星舒緩成分，它們是肌膚的溫柔守護者。<br/><br/>幫助舒緩肌膚，促進修復，讓肌膚在享受深層清潔的同時，也能感受到溫柔的呵護。",
          },
          {
            subTitle: "高活多肽因數",
            subDescription: "抗衰老的秘密武器",
            imageUrl:
              "https://upload.vwingist.com/melscn/0image/2025/03/5332871279379642743.png",
            detailTitle: "抗衰老的秘密武器",
            detailDescription:
              "隨著年齡的增長，肌膚的自我修復能力逐漸減弱。 <br/><br/>VESCOR面膜中的多肽修護因數，就是您抗衰老的秘密武器。它能促進細胞代謝再生，幫助肌膚恢復年輕活力，讓肌膚告別暗沉，迎接明亮。",
          },
        ],
      ],
    };
  },
};
</script>

<style scoped lang="less">
.product-detail-page-2 {
  .image-container {
    display: inline-block; /* 确保容器只占用图片的空间 */
    overflow: hidden; /* 隐藏超出容器的部分 */
  }
  .zoomable-image {
    transition: transform 0.3s ease; /* 添加过渡效果，使放大过程更平滑 */
    cursor: pointer;
    &:hover {
      transform: scale(1.07); /* 鼠标悬停时放大图片 */
    }
  }
  .top-section {
    margin-bottom: 120px;
    align-items: flex-start;
    .left-content {
      width: 985px;
      flex-shrink: 0;
      align-items: flex-start;
      .image-container {
        width: 389px;
        height: 613px;
        margin-right: 50px;
        img {
          width: 100%;
          height: auto;
        }
      }
      .text-content {
        flex: 1;
        color: #333333;
        .title {
          font-size: 26px;
          margin-bottom: 10px;
          font-family: "SourceHanSerifCN-Medium", sans-serif;
          font-weight: 600;
        }
        .sub_title {
          font-size: 24px;
          margin-bottom: 40px;
        }

        .description {
          .txt1 {
            font-size: 20px;
            font-family: "SourceHanSerifCN-Medium", sans-serif;
          }
          .txt2 {
            font-size: 18px;
            line-height: 30px;
            font-family: "SourceHanSerifCN-Light", sans-serif;
          }
          .mb_30 {
            margin-bottom: 30px;
          }
          .mb_40 {
            margin-bottom: 40px;
          }
        }

        .more-details-btn {
          width: 359px;
          height: 50px;
          border-radius: 0px 0px 0px 0px;
          border: 2px solid #000000;
          font-size: 16px;
          color: #000000;
          margin-top: 50px;
          cursor: pointer;
          position: relative;
          padding-left: 30px;
          box-sizing: border-box;
          background-color: #fff;
          .icon-xiangxiajiantou {
            position: absolute;
            right: 20px;
            font-size: 12px;
          }
        }
      }
    }
  }

  .bottom-section {
    .bottom-section-list {
      align-items: flex-start;
      &.new-class-2 {
        padding-left: 110px;
        padding-right: 110px;
        .detail-item {
          flex-shrink: 0;
          width: calc((100% - 100px) / 2);
        }
      }
      &.new-class-3 {
        margin-bottom: 100px;
        .detail-item {
          flex-shrink: 0;
          width: calc((100% - 100px) / 3);
        }
      }
      .detail-item {
        padding-right: 47px;
        box-sizing: border-box;
        border-right: 1px dashed #999999;
        &:last-child {
          border-right: none;
        }
        .top-part {
          width: 370px;
          height: 150px;
          background: #f9f9f9;
          box-shadow: inset 0px 0px 16px 1px rgba(84, 79, 90, 0.1);
          border-radius: 75px 75px 75px 75px;
          margin-bottom: 50px;
          padding: 0 2px 0 27px;
          box-sizing: border-box;
          .left-text {
            color: #333333;
            flex: 1;
            .sub-title {
              font-size: 30px;
              font-family: "SourceHanSerifCN-Medium", sans-serif;
              margin-bottom: 10px;
              font-weight: 600;
            }
            .sub-description {
              font-size: 24px;
              font-family: "SourceHanSerifCN-Medium", sans-serif;
            }
          }
          .right-image {
            width: 145px;
            height: 145px;
            border: 5px solid #fff;
            border-radius: 50%;
            box-sizing: border-box;
          }
        }
        .bottom-part {
          color: #333333;
          .detail-title {
            font-size: 24px;
            line-height: 34px;
            margin-bottom: 30px;
            font-family: "SourceHanSerifCN-Medium", sans-serif;
          }
          .detail-description {
            font-size: 16px;
            line-height: 28px;
            font-family: "SourceHanSerifCN-Light", sans-serif;
          }
        }
      }
    }
  }

  .more-details-wrap {
    position: relative;
    .more-details-ercode {
      width: 378px;
      height: 408px;
      background: url(https://upload.vwingist.com/melscn/0image/2025/04/5425508493632964248.png)
        no-repeat center;
      background-size: cover;
      position: absolute;
      bottom: -9px;
      left: 340px;
      z-index: 9999;
      .ercode_img {
        width: 230px;
        height: 230px;
        margin-bottom: 38px;
      }
      .ercode_txt {
        font-size: 16px;
        color: #333333;
        p {
          margin-bottom: 10px;
          font-family: "SourceHanSansCN-Light", sans-serif;
          span {
            font-family: "SourceHanSansCN-Medium", sans-serif;
          }
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
</style>